import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './components/dialog/dialog.component';
import { DialogDirective } from './components/dialog/dialog.directive';
import { MaterialModule } from 'src/shared-app-portal/material.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { InjectorModule } from '../app/shared/modules/injector.module';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { PhoneNumberDisplayPipe } from './pipes/phone-number-display.pipe';
import { EditPhoneComponent } from './components/phone/phone.component';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { AddressEditorComponent } from 'src/shared-app-portal/components/address-editor/address-editor.component';
import { RequiredAriaDirective } from './directives/required-aria.directive';
import { ReadOnlyAddressComponent } from './components/read-only-address/read-only-address.component';
import { CountryNamePipe } from './pipes/country-name.pipe';
import { AddressWarningDialogComponent } from 'src/portal/dialogs/address-warning.dialog/address-warning.dialog.component';

@NgModule({
  declarations: [
    DialogComponent,
    DialogDirective,
    PhoneNumberDisplayPipe,
    EditPhoneComponent,
    AddressEditorComponent,
    RequiredAriaDirective,
    ReadOnlyAddressComponent,
    CountryNamePipe,
    AddressWarningDialogComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    NgScrollbarModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    InjectorModule,
    FlexLayoutModule,
    NgxMatIntlTelInputComponent,
  ],
  exports: [
    DialogComponent,
    DialogDirective,
    MaterialModule,
    NgScrollbarModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    InjectorModule,
    FlexLayoutModule,
    PhoneNumberDisplayPipe,
    EditPhoneComponent,
    NgxMatIntlTelInputComponent,
    AddressEditorComponent,
    RequiredAriaDirective,
    ReadOnlyAddressComponent,
    CountryNamePipe,
    AddressWarningDialogComponent,
  ],
})
export class SharedAppPortalModule {}
